module.exports = __webpack_public_path__ + "img/1-4.47453a18.jpg";